// Node Modules
import React, { Component } from "react";

// Global Components
import Link from "components/link/link";
import Image from "components/image/image";
import Button from "components/button/button";

// Local CSS
import "./productPreview.css";
import "./productPreviewMobile.css";

class ProductPreview extends Component {
  constructor(props) {
    super(props);
    this.product = props.product;
  }

  render() {
    return (
      <div
        className={
          this.collection === "handPainted"
            ? "productPreview handPainted"
            : "productPreview activewear"
        }
      >
        <Link to={`/products/product/${this.product.handle}`} />
        <div className="buttonContainer">
          <Button color="orange">
            <p>{this.product.title}</p>
          </Button>
        </div>
        <div className="imageContainer">
          <Image src={`${this.product.images[0].src}`} alt="Garment" />
        </div>
      </div>
    );
  }
}

export default ProductPreview;
